export default class UIManager {
    constructor(modalSelector) {
        this.modalSelector = modalSelector;
    }

    initUI() {
        if (jQuery('.order-total-section .total-loader').length === 0) {
            jQuery('.order-total-section').append('<div class="total-loader" style="display: none;"><div class="spinner"></div></div>');
        }
    }

    showTotalLoader() {
        jQuery('.order-total-section .total-loader').show();
        jQuery('.total-value, .subtotal-value, .payment-discount-value, .coupon-discount-value, .total-discount-value')
            .css('opacity', '0.5');
    }

    hideTotalLoader() {
        jQuery('.order-total-section .total-loader').hide();
        jQuery('.total-value, .subtotal-value, .payment-discount-value, .coupon-discount-value, .total-discount-value')
            .css('opacity', '1');
    }

    showCouponMessage(message, type) {
        const messageEl = jQuery('.coupon-message');
        messageEl.text(message);
        messageEl.removeClass('success error');
        if (type) {
            messageEl.addClass(type);
        }
    }

    displayModal() {
        jQuery(this.modalSelector).css('display', 'block');
    }

    hideModal() {
        jQuery(this.modalSelector).hide();
    }

    setRequestLoader() {
        jQuery('.wvp-credit-fields, .saved-card-cvv')
            .addClass('processing')
            .block({
                message: null,
                overlayCSS: {
                    background: '#fff',
                    opacity: 0.6
                }
            });
    }

    removeRequestLoader() {
        jQuery('.wvp-credit-fields, .saved-card-cvv')
            .removeClass('processing')
            .unblock();
    }

    updateProductInfo(title, price) {
        jQuery('.product-info').html(`
            <h3>${title}</h3>
            <p>Valor: ${price}</p>
        `);
    }
}